import { render, staticRenderFns } from "./LPUserCarousel.vue?vue&type=template&id=19b66210&scoped=true"
import script from "./LPUserCarousel.vue?vue&type=script&lang=ts"
export * from "./LPUserCarousel.vue?vue&type=script&lang=ts"
import style0 from "./LPUserCarousel.vue?vue&type=style&index=0&id=19b66210&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b66210",
  null
  
)

export default component.exports